<template>
	<v-container fill-height>
		<v-layout column>
			<v-spacer />
			<v-flex>
				<img :src="logo" />
			</v-flex>
			<v-flex justify-center align-center>
				<a href="/"
					><p class="center-text main-font-color">
						{{ $t(`message.signUpRedirect`) }}
					</p>
				</a>
			</v-flex>
			<v-spacer />
		</v-layout>
	</v-container>
</template>

<script>
import AppConfig from "Constants/AppConfig";

export default {
	data: () => ({
		logo: AppConfig.appLogo2,
	}),
	mounted: function() {
		setTimeout(() => this.$router.push({ path: "/" }), 2000);
	},
};
</script>

<style lang="scss" scoped>
.center-text {
	text-align: center;
}
.main-font-color {
	color: #262261;
}
</style>
